import React from "react";

/**
 * DiagnosticAssignmentsTable Component
 * Displays current diagnostic assignments in a table format
 * Props:
 * - assignments: Array of assignment objects
 * - onCancelAssignment: Callback when cancel button is clicked
 * - onViewAnswers: Callback when employee name is clicked (for completed submissions)
 */
export default function DiagnosticAssignmentsTable({
  assignments = [],
  onCancelAssignment,
  onViewAnswers,
  onAssignForm,
}) {
  // Get status badge style
  const getStatusBadge = (status) => {
    const styles = {
      pending: { bg: "#fef3c7", color: "#d97706", label: "Pending" },
      in_progress: { bg: "#dbeafe", color: "#2563eb", label: "In Progress" },
      completed: { bg: "#dcfce7", color: "#16a34a", label: "Completed" },
      expired: { bg: "#fee2e2", color: "#dc2626", label: "Expired" },
    };
    return styles[status] || styles.pending;
  };

  if (assignments.length === 0) {
    return null;
  }

  return (
    <div className="cd-card-block" style={{ marginTop: "16px" }}>
      <div className="cd-section-title-main">Current Diagnostic Assignments</div>
      <div className="cd-assignments-table-wrapper">
        <table className="cd-assignments-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Form</th>
              <th>Type</th>
              <th>Target</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assignments.map((assignment) => {
              const badge = getStatusBadge(assignment.status);
              const hasSubmission = assignment.submission;
              return (
                <tr key={assignment._id}>
                  <td>
                    {hasSubmission ? (
                      <button
                        className="cd-employee-link"
                        onClick={() => onViewAnswers?.(assignment)}
                      >
                        {assignment.assignee?.firstName}{" "}
                        {assignment.assignee?.lastName}
                      </button>
                    ) : (
                      <>
                        {assignment.assignee?.firstName}{" "}
                        {assignment.assignee?.lastName}
                      </>
                    )}
                  </td>
                  <td>{assignment.template?.title || "—"}</td>
                  <td>
                    <span
                      className={`cd-type-badge cd-type-${assignment.evaluationType}`}
                    >
                      {assignment.evaluationType === "self"
                        ? "Self"
                        : "Colleague"}
                    </span>
                  </td>
                  <td>
                    {assignment.evaluationType === "self"
                      ? "—"
                      : `${assignment.target?.firstName} ${assignment.target?.lastName}`}
                  </td>
                  <td>
                    <span
                      className="cd-status-badge"
                      style={{
                        backgroundColor: badge.bg,
                        color: badge.color,
                      }}
                    >
                      {badge.label}
                    </span>
                  </td>
                  <td>
                    <div className="cd-assignment-actions">
                      {assignment.requestStatus === "pending_approval" && (
                        <button
                          className="cd-assign-form-btn"
                          onClick={() => onAssignForm?.(assignment)}
                        >
                          Assign form
                        </button>
                      )}
                      {assignment.status === "pending" && (
                        <button
                          className="cd-cancel-btn"
                          onClick={() => onCancelAssignment?.(assignment._id)}
                        >
                          Cancel
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
